import React from 'react'
import _ from 'lodash'
import { Row } from 'antd'
import { P } from 'konsys-ui'
import { Wrapper } from '../../components/client-components'
import { BANK_ACCOUNT_TYPE, BANK_ACCOUNT_TYPE_TH } from './constants'
import history from '../../history'
import { theme } from '../../styles/_variables'

export const bankTextSelector = (e) => {
  switch (e) {
    case BANK_ACCOUNT_TYPE.SAVING:
      return BANK_ACCOUNT_TYPE_TH.SAVING
    case BANK_ACCOUNT_TYPE.FIXED:
      return BANK_ACCOUNT_TYPE_TH.FIXED
    case BANK_ACCOUNT_TYPE.CURRENT:
      return BANK_ACCOUNT_TYPE_TH.CURRENT
    case BANK_ACCOUNT_TYPE.FOREIGN:
      return BANK_ACCOUNT_TYPE_TH.FOREIGN
    case BANK_ACCOUNT_TYPE.BILL:
      return BANK_ACCOUNT_TYPE_TH.BILL
    case BANK_ACCOUNT_TYPE.LOTTERY:
      return BANK_ACCOUNT_TYPE_TH.LOTTERY
    case BANK_ACCOUNT_TYPE.BOND:
      return BANK_ACCOUNT_TYPE_TH.BOND
    default:
      return 'ไม่ระบุ'
  }
}

export const a = (e) => {
  const b = 1
  return e
}
